

<template>
<div>
    <ag-grid-vue style="height: 291px; width:100%; font-size: 12px" @rowDataChanged="handleRowDataChanged($event)"  @cellFocused="cellFocused" @row-drag-enter="onRowDragEnter" @row-drag-end="onRowDragEnd" @column-moved ="columnMoved" @row-drag-move="onRowDragMove" @row-drag-leave="onRowDragLeave" :rowDragManaged="true" :animateRows="true" class="ag-theme-balham" :columnDefs="columnDefs" :rowData="rowData" :gridOptions="gridOptions" @grid-ready="onGridReady" :frameworkComponents="frameworkComponents" :context="context" :defaultColDef="defaultColDef"></ag-grid-vue>
</div>
</template>

<script>
import {
    AgGridVue
} from 'ag-grid-vue'
import {
    AllCommunityModules
} from '@ag-grid-community/all-modules'
import { InputComponent, DateComponent, TimeComponent, DetailComponent } from '@/utils/reg.enroll.grid.js'
export default {
    props: ['parentColumns', 'parentRowdatas', 'gridIndex', 'idxOfChanges'],
    components: {
        AgGridVue,
    },
    data: () => ({
        /** ag-grid 옵션 변수들 선언 */
        gridOptions: null, // 그리드에 적용할 각 옵션 (열, 행, 헤더, 편집옵션 등)
        gridApi: null, // 그리드에 적용할 각 api ( 사이즈, get, set, 노드접근, 선택, 정렬 등)
        columnApi: null, // 컬럼에 사용할 각 api ( 행의 사이즈, get, set)
        columnDefs: null, // 컬럼에 들어갈 값 (헤더 데이터)
        rowData: null, // 열에 들어갈 값 (기본 데이터)
        defaultColDef: null, // 기본 컬럼 셋팅 (따로 컬럼에 옵션을 지정하지 않은 경우)
        modules: AllCommunityModules, // Ag-grid 모듈 사용 변수

        index: '', // 해당 그리드가 몇번째 그리드인지 index 넘버
        idxOfChange: 0, // 해당 그리드가 몇번째 수정중인지 확인
    }),

    beforeMount() {
        var me = this;
        if (this.parentColumns) {
            this.columnDefs = this.parentColumns
        }

        if (this.parentRowdatas) {
            this.rowData = this.parentRowdatas
        }

        console.log('this.rowData', this.rowData)

        this.index = this.rowData[0].index
        console.log('this.idxOfChanges', this.idxOfChanges)
        this.idxOfChange = this.idxOfChanges[this.gridIndex].index

        console.log(' this.idxOfChange', this.idxOfChange)

        // 그리드에 적용가능한 여러가지 옵션 사항을 설정합니다.
        this.gridOptions = {
            headerHeight: 36,
            rowHeight: 47,
            enableColResize: true,
            stopEditingWhenGridLosesFocus: true,
            rowSelection: 'single', // 그리드 선택 이벤트 추가 single,multiple
            onRowClicked:function(event){ //그리드 선택 이벤트
                // console.log("on row click");
                // console.log(event);
                me.$emit('selectRow',event.rowIndex);
            }
        }

        // 그리드에 적용할 컴포넌트 설정 (utils/reg.userInfo.grid.js 파일에 컴포넌트 지정)
        this.frameworkComponents = {
            InputComponent: 'InputComponent',
            DateComponent: 'DateComponent',
            TimeComponent: 'TimeComponent',
            DetailComponent: 'DetailComponent'
        }

        // 그리드에 삽입된 외부 컴포넌트에서 현재 컴포넌트 데이터에 접근하기 위함
        this.context = {
            componentParent: this
        }

        // 기본 컬럼 세팅 정의
        this.defaultColDef = {
            resizable: true // 컬럼 Width 조정가능
        }
    },

    beforeDestroy() {
        console.log('그리드 메모리 해제')
    },

    watch: {
        parentColumns() {
            this.columnDefs = this.parentColumns
            console.log('columndata변경', this.columnDefs)
        },

        parentRowdatas() {
            console.log('rowdata변경')
            this.rowData = this.parentRowdatas
        },

        idxOfChanges: {
            handler() {
                this.idxOfChange = this.idxOfChanges[this.gridIndex].index
            },
            deep: true
        }
    },

    methods: {


        //row data change 시 추가 삭제한 index로 스크롤
        handleRowDataChanged(event){
            const index = this.rowData.length - 1;
            this.gridApi.ensureIndexVisible(index, 'bottom');
        },

        // 셀 포커싱시 이벤트
        cellFocused(event) {
            this.$nextTick(() => {
                if (event.column) {
                    console.log('event', event)
                    console.log(event.column.colDef.field + this.index.toString() + this.idxOfChange + event.rowIndex.toString())
                    if (document.getElementById(event.column.colDef.field + this.index.toString() + this.idxOfChange + event.rowIndex.toString())) {
                        document.getElementById(event.column.colDef.field + this.index.toString() + this.idxOfChange + event.rowIndex.toString()).focus()
                    }
                }
            })
        },

        // 행 드래그 종료시 이벤트 함수
        onRowDragEnd() {
            this.gridIndex = this.rowData[0].index
            this.gridApi.refreshClientSideRowModel()
            var tempData = []
            this.gridApi.forEachNode(function (rowNode) {
                tempData.push(rowNode.data)
            });

            this.parentRowdatas = JSON.parse(JSON.stringify(tempData))
            this.$emit('dragEvent', this.parentRowdatas, this.gridIndex)
        },
        
        // 컬럼 이동시 작동
        columnMoved () {
            this.gridIndex = this.rowData[0].index
            console.log('this.gridColumnApi.getAllGridColumns();', this.gridColumnApi.getAllGridColumns())
            var columnOrder = ''
            for (var column of this.gridColumnApi.getAllGridColumns()) {
                if (column.colDef.headerName === '') {
                    continue
                } else {
                    if (columnOrder === '') {
                        columnOrder += column.colDef.headerName
                    } else {
                        columnOrder += '^'+column.colDef.headerName
                    }
                }
            }

            this.$emit('dragColumnEvent', columnOrder, this.gridIndex)

            console.log('columnOrder', columnOrder)
        },

        onGridReady(params) {
            console.log('params-modal', params)
            this.gridApi = this.gridOptions.api
            this.gridColumnApi = this.gridOptions.columnApi
        },

        gridSizeFit(params) {
            // 모니터나 브라우저 크기에 따라 반응하여 그리드 컬럼 사이즈를 조정합니다.
            if (window.innerWidth > 800) {
                params.api.sizeColumnsToFit() // 가로 스크롤바가 생기지 않도록 컬럼 사이즈를 그리드에 꼭 맞게 조정합니다.
            } else {
                // 컬럼의 데이터값이 잘리지 않도록 조정합니다.
                let allColumnIds = []
                this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
                    allColumnIds.push(column.colId)
                })
                this.gridOptions.columnApi.autoSizeColumns(allColumnIds)
            }
        }
    }
}
</script>

